import type { FeatureVariant } from "../../data/siteContent";
import { getEffectsScreenshotDisplaySize } from "../../data/siteAssets";
import { AppScreenshot } from "../ui/AppScreenshot";

import styles from "./FeatureMockup.module.css";

type FeatureMockupProps = {
  variant: FeatureVariant;
};

function join(...parts: (string | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}

export function FeatureMockup({ variant }: FeatureMockupProps) {
  const isAtmosphere = variant === "atmosphere";
  const effectsDisplayWidth = isAtmosphere
    ? getEffectsScreenshotDisplaySize().width
    : undefined;

  return (
    <div
      className={join(
        styles.frame,
        isAtmosphere ? styles.frameAtmosphere : undefined,
      )}
      data-variant={variant}
    >
      <div className={styles.chrome}>
        <span />
        <span />
        <span />
      </div>
      <div
        className={join(
          styles.screen,
          styles.screenScreenshot,
          isAtmosphere ? styles.screenAtmosphere : undefined,
        )}
      >
        <AppScreenshot variant={variant} displayWidth={effectsDisplayWidth} />
      </div>
    </div>
  );
}
